import React, {
  createContext,
  useState,
  useContext,
  Dispatch,
  SetStateAction,
} from "react";

export interface GlobalStateDesbloqueio {
  cpf: string;
  dataNascimento: string;
  numeroCartao: string;
  senha: string;
}

const GlobalStateContextDesbloqueio = createContext({
  desbloqueioData: {} as Partial<GlobalStateDesbloqueio>,
  setDesbloqueioData: {} as Dispatch<
    SetStateAction<Partial<GlobalStateDesbloqueio>>
  >,
});

const GlobalStateProviderDesbloqueio = ({
  children,
  value = {} as GlobalStateDesbloqueio,
}: {
  children: React.ReactNode;
  value?: Partial<GlobalStateDesbloqueio>;
}) => {
  const [desbloqueioData, setDesbloqueioData] = useState(value);
  return (
    <GlobalStateContextDesbloqueio.Provider
      value={{ desbloqueioData, setDesbloqueioData }}
    >
      {children}
    </GlobalStateContextDesbloqueio.Provider>
  );
};

const useGlobalStateDesbloqueio = () => {
  const context = useContext(GlobalStateContextDesbloqueio);
  if (!context) {
    throw new Error(
      "useGlobalStateDesbloqueio must be used within a GlobalStateContextDesbloqueio"
    );
  }
  return context;
};

export { GlobalStateProviderDesbloqueio, useGlobalStateDesbloqueio };
